<template>
    <div class="boxCountDown">

        <div class="content" v-if="content">
            <h2>Get ready for the launch of Zodiac Battle Arena!</h2>
            <p>We will be live in</p>
        </div>
        <div class="content" v-if="!content">
            <h2>100 Zodiac Genesis sold out!</h2>
            <p>Grab your Zodiac NFT and join the force in</p>
        </div>
        <div class="countdown-timer">
            <div class="countdown-item">
                <div class="countdown-value">{{ days }}</div>
                <p>Days</p>
            </div>
            <div class="countdown-item" >
                <div class="countdown-value">{{ hours }}</div>
                <p>Hrs</p>
            </div>
            <div class="countdown-item" >
                <div class="countdown-value">{{ minutes }}</div>
                <p>Mins</p>
            </div>
            <div class="countdown-item">
                <div class="countdown-value">{{ seconds }}</div>
                <p>Secs</p>
            </div>
        </div>
        <Progress />

        <ul>
            <!-- <li>
                <router-link to="/buy-nft" class="cta">
                    <span class="span">Buy NFT</span>
                    <span class="second">
                        <svg
                            width="50px"
                            height="20px"
                            viewBox="0 0 66 43"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <g
                            id="arrow"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            >
                            <path
                                class="one"
                                d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                class="two"
                                d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                class="three"
                                d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            </g>
                        </svg>
                    </span>
                </router-link>
            </li> -->
            <li>
                <!-- <router-link to="/how-to-buy" class="cta">
                    <span class="span">How To Buy</span>
                    <span class="second">
                        <svg
                            width="50px"
                            height="20px"
                            viewBox="0 0 66 43"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <g
                            id="arrow"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            >
                            <path
                                class="one"
                                d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                class="two"
                                d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                class="three"
                                d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                fill="#FFFFFF"
                            ></path>
                            </g>
                        </svg>
                    </span>
                </router-link> -->
            </li>
        </ul>
    </div>
</template>

<script>
    import Progress from "@/components/Progress.vue";
    export default {
        components: {
            Progress,
        },
        data() {
            return {
                countdownDate_1: new Date('2024/5/10 21:00').getTime(),
                countdownDate_2: new Date('2024/5/24 21:00').getTime(),
                countdownInterval: null,
                content: true,
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            };
        },
        mounted() {
            this.startCountdown();
            
        },
        beforeDestroy() {
            this.stopCountdown();
        },
        methods: {
            startCountdown() {
                this.countdownInterval = setInterval(() => {
                    const currentTime = Date.now();
                    
                    const timeDifference_1 = this.countdownDate_1 - currentTime;
                    const timeDifference_2 = this.countdownDate_2 - currentTime;
                    if (timeDifference_1 <= 0) {
                        this.days = this.formatNumber(Math.floor(timeDifference_2 / (1000 * 60 * 60 * 24)));
                        this.hours = this.formatNumber(Math.floor((timeDifference_2 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                        this.minutes = this.formatNumber(Math.floor((timeDifference_2 % (1000 * 60 * 60)) / (1000 * 60)));
                        this.seconds = this.formatNumber(Math.floor((timeDifference_2 % (1000 * 60)) / 1000));
                        this.content = false;
                        if(timeDifference_2 <= 0){
                            this.stopCountdown();
                        }
                    }
                    else{
                        this.days = this.formatNumber(Math.floor(timeDifference_1 / (1000 * 60 * 60 * 24)));
                        this.hours = this.formatNumber(Math.floor((timeDifference_1 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                        this.minutes = this.formatNumber(Math.floor((timeDifference_1 % (1000 * 60 * 60)) / (1000 * 60)));
                        this.seconds = this.formatNumber(Math.floor((timeDifference_1 % (1000 * 60)) / 1000));
                    }
                }, 1000);
            },
            stopCountdown() {
                clearInterval(this.countdownInterval);
                this.days = 0;
                this.hours = 0;
                this.minutes = 0;
                this.seconds = 0;
            },
            
            formatNumber(value) {
                return value.toString().padStart(2, '0');
                
            },
        },
    }
</script>

<style lang="scss" scoped>
    .boxCountDown{
        text-align: center;
        padding: 80px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .content{
            padding: 0 20px;
            h2{
                font-size: 28px;
                font-weight: bold;
            }
        }
        .countdown-timer {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 50px;
            margin: 30px 0 50px;
            @media (max-width: 992px){
                gap: 30px;
            }
            .countdown-item {                
                .countdown-value{
                    font-size: 50px;
                    font-weight: bold;
                }
            }
        }
        ul {
            display: flex;
            gap: 25px;
            align-items: center;
            height: 72px;
            padding: 10px 0;
            margin-top: 30px;
            @media (max-width: 992px) {
                flex-wrap: wrap;
                justify-content: center;
                height: auto;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
            }
            li {
                a {
                    font-size: 16px;
                    font-weight: 600;
                    text-transform: uppercase;
                    display: inline-block;
                    text-align: center;
                    line-height: 44px;
                    text-decoration: none;
                    @media (max-width: 992px){
                        font-size: 12px;
                        width: 170px;
                    }
                }
                &:first-child {
                    a {
                        color: white;
                        background: black;
                        // border-radius: 5px;
                        border: 1px solid black;
                        font-weight: bold;
                        padding: 0px 15px;
                        // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
                        &:hover {
                            color: #000;
                            background: #fff;
                            border: 1px solid #000;
                        }
                    }
                }
                &:last-child {
                    a {
                        color: #fff;
                        padding-right: 0;
                        &:hover {
                            // background: #000;
                            border: 1px solid #fff;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>